export default filter => {
  let formattedValue = filter?.value;

  if (filter?.type === 'boolean') {
    const [value] = formattedValue ?? [];
    formattedValue = [value.toString()];
  }

  return { key: filter?.key, operator: filter?.operator, values: formattedValue };
};
